"use strict";

require("./modals/incomplete-profile-warning.modal.js");

angular.module("customer")
.directive("fullProfileOnly", function($rootScope, ModalService) {
    return {
        restrict: "A",
        scope: false,
        link: function(scope, iElement, iAttrs, controller) {
            // if user.info have not been implemented
            if (!$rootScope.user) {
                // we wait for the promise to broadcast the information
                scope.$on("UserUpdated", function(event, user) {
                    if (!user || !user.has_profile_completed["all"]) {
                        iElement.off("click");
                        iElement.attr("wg-click", "displayProfileCompletedWarning()");
                        iElement.on("click", controller.displayProfileCompletedWarning);
                    }
                });
            }
            // if user.info have been implemented
            else if ($rootScope.user && $rootScope.user.has_profile_completed && !$rootScope.user.has_profile_completed["all"]) {
                iElement.off("click");

                iElement.attr("wg-click", "displayProfileCompletedWarning()");
                iElement.on("click", controller.displayProfileCompletedWarning);
            }
        },
        controller: function($scope) {
            this.displayProfileCompletedWarning = function() {
                ModalService.showModal({
                    templateUrl: require("./modals/incomplete-profile-warning.modal.html"),
                    controller: "incompleteProfileWarning",
                    controllerAs: "incompleteProfileWarningCtrl",
                    inputs: {
                        $attrs: {
                            isProfileIncomplete: !$rootScope.user.has_profile_completed["profile"],
                            isCustomerIncomplete: !$rootScope.user.has_profile_completed["customer"]
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        modal.element.remove();
                    });
                });
            };
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/full-profile-only/full-profile-only.directive.js
// module id = 825
// module chunks = 0